import { Injectable } from '@angular/core';
import { RequestService } from './request.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NationalityService {
  constructor(private requestService: RequestService) {}

  getAllNationality() {
    return this.requestService.getJSON<any>(`/nationality`, {
      data: {},
      option: {
        is_loading: true,
      },
    });
  }

  getAllNationalityWithPagination(
    page: number,
    count: number,
    search: string = ''
  ): Observable<any> {
    return this.requestService.getJSON<any>(`/nationality`, {
      data: Object.assign({ page, limit: count, name: search }),
      option: {
        is_loading: true,
      },
    });
  }

  getNationalityID(id: string) {
    return this.requestService.getJSON<any>(`/nationality/${id}`, {
      data: {},
      option: {
        is_loading: true,
      },
    });
  }
}
